import { render, staticRenderFns } from "./DeleteEventModal.html?vue&type=template&id=9323c31a&scoped=true&"
import script from "./DeleteEventModal.vue?vue&type=script&lang=js&"
export * from "./DeleteEventModal.vue?vue&type=script&lang=js&"
import style0 from "./DeleteEventModal.scss?vue&type=style&index=0&id=9323c31a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9323c31a",
  null
  
)

export default component.exports